<template>
  <el-dialog @open="open" title="Registrar Cobrança" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="450px">
    <el-form :model="cobranca" :rules="validacao" ref="form" size="small" label-position="top" hide-required-asterisk :show-message="false">

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Data/Hora" prop="datahora">
            <el-input v-model="cobranca.dataHora" v-mask="'##/##/#### ##:##'" readonly/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Usuário">
            <el-input v-model="cobranca.usuario.nome" readonly/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="spanCanalArea">
          <el-form-item label="Canal" prop="canal">
            <el-select
              v-model="cobranca.canal"
              value-key="id"
              placeholder
              filterable
              clearable
              default-first-option
              @clear="cobranca.canal = undefined"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in canalCobrancas"
                :key="item.id"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label=" " v-if="exibirCanalOutros">
            <el-input v-model="cobranca.canalOutros"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="height: 350px;">
        <el-col :span="24" style="height: 100%;">
          <el-form-item label="Descrição" prop="descricao" class="obs-form-item" style="height: 100%;">
            <el-input
              v-model="cobranca.descricao"
              type="textarea"
              style="height: 100%"
              class="obs-text-area"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarHandler" type="success" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Util from "../../../util/funcoes";
import { CANAIS_COBRANCAS } from '../../../util/constantes';

export default {
  props: {
    visibility: Boolean,
    reciboSelecionado: Object
  },

  data() {
    return {
      cobranca: {
        dataHora: Util.agora(),
        descricao: "",
        usuario: ""
      },

      validacao: {
        canal: [{ required: true }]
      },
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.loading,
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    canalCobrancas() {
      return CANAIS_COBRANCAS;
    },

    exibirCanalOutros() {
      if(this.cobranca.canal) {
        if(this.cobranca.canal == 'OUTROS') {
          return true
        } else {
          return false
        }
      } else {
        return false;
      }
    },

    spanCanalArea() {
      return this.cobranca.canal == 'OUTROS' ? 12 : 24
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
      'gravarCobranca'
    ]),

    gravarHandler() {
      this.$refs['form'].validate(elFormValidation => {
        const formIsInvalid = !elFormValidation;
        if(formIsInvalid) {
          this.$alert("Preencha os campos obrigatórios!", "Alerta", { confirmButtonText: 'Ok' });
          return;
        }

        this.gravar();
      })
    },

    gravar() {
      const payload = {
        descricao: this.cobranca.descricao,
        canal: this.cobranca.canal,
        dataHora: this.cobranca.dataHora,
        recibo: this.reciboSelecionado,
        usuario: this.cobranca.usuario,
        cliente: this.reciboSelecionado.cliente
      }
      if(this.cobranca.canal == 'OUTROS') { payload.canalOutros = this.cobranca.canalOutros }
  
      this.showLoading();

      this.gravarCobranca(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.$message.success(response.mensagem)
            this.fechar();
            break;
          case 'ERRO':
            this.$message.error(response.mensagem)
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      }).finally(() => {
        this.hideLoading();
      })
    },

    open() {
      this.cobranca = {
        dataHora: Util.agora(),
        descricao: "",
        usuario: ""
      }
      this.cobranca.usuario = this.usuarioLogado
    },

    fechar() {
      this.$emit("close")
    }
  },
}
</script>